"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _TopicChooser = _interopRequireDefault(require("./TopicChooser.scss"));

var _DrupalNugget = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/DrupalNugget.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _strings = require("../../../../config/strings");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _DateTimeHelper = require("../../../helpers/DateTimeHelper");

var _Topic = _interopRequireDefault(require("./Topic"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var TopicChooser = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(TopicChooser, _Kesi2BasicComponent);

  var _super = _createSuper(TopicChooser);

  function TopicChooser(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, TopicChooser);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeCurrentDay", function (day) {
      var newDay = day;
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - (0, _parseInt2["default"])(newDay));

      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_START_DATE, currentDate);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeTopic", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(newTopic, path) {
        var data, oldTopic, oldTopicName, schichtboxData, schichtboxDataString, schichtarbeitData, schichtarbeitDataString, currentDay, storedEarlyPushTime, storedLatePushTime, storedData, storedTopicData, schichtboxDataToLoad, schichtarbeitDataToLoad, topicToSet, updateValue;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {};
                oldTopic = _DataStore["default"].getElementByPathImmediately(path);
                oldTopicName = oldTopic.name;

                if (!(oldTopicName === newTopic.topicName)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                schichtboxData = _DataStore["default"].getElementByPathImmediately('public.schichtbox');
                schichtboxDataString = (0, _stringify["default"])(schichtboxData);
                schichtarbeitData = _DataStore["default"].getElementByPathImmediately('public.schichtarbeit');
                schichtarbeitDataString = (0, _stringify["default"])(schichtarbeitData);
                currentDay = (0, _DateTimeHelper.getCurrentDay)();
                console.log('currentDay in TopicChooser', currentDay);
                data["".concat(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_STORAGE, ".").concat(oldTopicName)] = {
                  schichtbox: schichtboxDataString,
                  schichtarbeit: schichtarbeitDataString,
                  currentDay: currentDay
                };
                storedEarlyPushTime = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_EARLY_PUSH_TIME);
                storedLatePushTime = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_LATE_PUSH_TIME);
                storedData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_STORAGE);

                if (!(storedData && storedData[newTopic.topicName])) {
                  _context.next = 33;
                  break;
                }

                storedTopicData = storedData[newTopic.topicName];
                schichtboxDataToLoad = storedTopicData.schichtbox ? JSON.parse(storedTopicData.schichtbox) : {};
                schichtarbeitDataToLoad = storedTopicData.schichtarbeit ? JSON.parse(storedTopicData.schichtarbeit) : {};
                data['public.schichtbox'] = schichtboxDataToLoad;
                data['public.schichtarbeit'] = schichtarbeitDataToLoad;
                data[_DataStore.DATA_STORE_PATHS.SCHICHTBOX_EARLY_PUSH_TIME] = storedEarlyPushTime;
                data[_DataStore.DATA_STORE_PATHS.SCHICHTBOX_LATE_PUSH_TIME] = storedLatePushTime;
                _context.next = 25;
                return _DataStore["default"].setSingleData('public.schichtbox', {});

              case 25:
                _context.next = 27;
                return _DataStore["default"].setSingleData('public.schichtarbeit', {});

              case 27:
                _context.next = 29;
                return _DataStore["default"].setData(data);

              case 29:
                console.log('storedTopicData.currentDay in TopicChooser', storedTopicData.currentDay);

                _this.changeCurrentDay(storedTopicData.currentDay ? storedTopicData.currentDay : 0);

                _context.next = 36;
                break;

              case 33:
                _context.next = 35;
                return _DataStore["default"].setData(data);

              case 35:
                _this.changeCurrentDay(0);

              case 36:
                topicToSet = {
                  name: newTopic.topicName,
                  text: newTopic.topicText,
                  imgPath: newTopic.topicImage,
                  uuid: newTopic.uuid
                };
                _context.next = 39;
                return _DataStore["default"].setSingleData(path, topicToSet);

              case 39:
                updateValue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE) || 0;
                _context.next = 42;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, updateValue + 1);

              case 42:
                _this.setState({
                  topic: topicToSet
                });

              case 43:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.state = {
      topic: null
    };
    return _this;
  }

  (0, _createClass2["default"])(TopicChooser, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nugget = _KESI2Helper["default"].getLikertResult();

      if (nugget && nugget.dataStorePath) {
        var currentTopic = _DataStore["default"].getElementByPathImmediately(nugget.dataStorePath);

        this.setState({
          topic: currentTopic
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var nugget = _KESI2Helper["default"].getLikertResult();

      var storedData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_STORAGE);

      if (nugget) {
        var path = nugget.dataStorePath;
        var topics = nugget.topics;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _TopicChooser["default"].container
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _TopicChooser["default"].wrapper
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _TopicChooser["default"].headline
        }, "Mein Ziel"), /*#__PURE__*/_react["default"].createElement("div", {
          className: _TopicChooser["default"].infotext
        }, "Hier kannst du ausw\xE4hlen, an welchem Themengebiet Du arbeiten m\xF6chtest. Du kannst jederzeit wechseln, aber die besten Resultate erreichst Du, wenn Du 14 Tage bei einem Thema bleibst."), /*#__PURE__*/_react["default"].createElement("div", null, (0, _keys["default"])(topics).length > 0 && topics.map(function (topic) {
          if (!topic) {
            return null;
          }

          var currentDay;

          if (_this2.state.topic && _this2.state.topic.name === topic.topicName) {
            currentDay = (0, _DateTimeHelper.getCurrentDay)();
          } else {
            var _storedData$topic$top;

            currentDay = storedData && storedData.hasOwnProperty(topic === null || topic === void 0 ? void 0 : topic.topicName) && ((_storedData$topic$top = storedData[topic.topicName]) === null || _storedData$topic$top === void 0 ? void 0 : _storedData$topic$top.currentDay);
          }

          return /*#__PURE__*/_react["default"].createElement(_Topic["default"], {
            key: topic.topicName,
            isActive: _this2.state.topic && _this2.state.topic.name === topic.topicName,
            topic: topic,
            path: path,
            changeTopic: _this2.changeTopic,
            day: currentDay
          });
        }))));
      }
    }
  }]);
  return TopicChooser;
}(_KESI2BasicComponent["default"]);

exports["default"] = TopicChooser;
TopicChooser.propTypes = {};
TopicChooser.defaultProps = {};